import React from "react";
import AdminTable from "../users/AdminTable";
import RiskCenterTable from "../users/RiskCenterTable";

/** Admin > Users: list, filters, create-user entry. */
function UsersScreen({ users, openpopup, company_id }) {
  const isCompanyMode =
    company_id !== null &&
    company_id !== undefined &&
    String(company_id) !== "";

  return (
    <div className="h-full w-full mt-4">
      <div className="flex flex-col gap-2">
        {isCompanyMode ? (
          <RiskCenterTable
            data={users}
            companyId={company_id}
          />
        ) : (
          <AdminTable
            data={users}
            openpopup={openpopup}
          />
        )}
      </div>
    </div>
  );
}

export default UsersScreen;